$(function() {
	
	/* Header slider -- begin */

	(function() {

		var slide_container = $('#slide-container');

		$('.toggle-left-slide').on('click', function() {
			slide_container.toggleClass('slide-left');
		});

		$('.toggle-right-slide').on('click', function() {
			slide_container.toggleClass('slide-right');
		});

	})();

	/* Header slider -- end */

	/* Social share -- begin */

	if ($('#social-share').length) {

		$('.pinterest-share').sharrre({
	        share: {
	            pinterest: true
	        },
	        template: 'Share',
	        enableHover: false,
	        enableCounter: false,
	    }).on('click',function() {
	        var data = $(this).data();
	        var pinBaseUrl = "http://pinterest.com/pin/create/button/";
	        var pinUrl = pinBaseUrl + '?url=' + data.url + '&media=' + data.media + '&description=' + data.description;
	        window.open(pinUrl, 'signin', 'height=300,width=665');
	        return false;
	    });            

    
	    $('.twitter-share').sharrre({
	        share: {
	            twitter: true
	        },
	        template: 'Share',
	        enableHover: false,
	        enableCounter: false,
	        buttons: {twitter: {via: ''}},
	        click: function(api, options) {
	            api.simulateClick();
	            api.openPopup('twitter');
	            return false;
	        }
	    });

	    $('.facebook-share').sharrre({
	        share: {
	            facebook: true
	        },
	        template: 'Share',
	        enableHover: false,
	        enableCounter: false,
	        click: function(api, options) {
	            api.simulateClick();
	            api.openPopup('facebook');
	            return false;
	        }
	    });

	}

	/* Social share -- end */

	/* Home page slider -- begin */

	if ($('#homepage-slider').length) {
	
		

		

		

		$('#homepage-slider').slick({
			fade: true,
			arrows: true,
			speed: 500,
			slide: '.slide',		
			nextArrow: '<span class="slick-next slick-control"><?xml version="1.0" encoding="utf-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="81 -123.7 438.4 994.4" enable-background="new 81 -123.7 438.4 994.4" xml:space="preserve"><g><polygon points="519.1,373.4 519.4,373.6 107.8,870.7 81,848.4 474.2,373.6 81,-101.3 107.8,-123.7 519.4,373.2 	"/></g></svg></span>',
			prevArrow: '<span class="slick-prev slick-control"><?xml version="1.0" encoding="utf-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="81 -123.7 438.4 994.4" enable-background="new 81 -123.7 438.4 994.4" xml:space="preserve"><g><polygon points="81.2,373.4 81,373.6 492.6,870.7 519.4,848.4 126.2,373.6 519.4,-101.3 492.6,-123.7 81,373.2 	"/></g></svg></span>'
		});
	}

	/* Home page slider -- end */

});
